<template>
  <div class="dimed">
    <!-- 컨텐츠 영역 테두리 아래 요소(.layer)에 admin 클래스 추가 -->
    <div class="layer admin">
      <!-- header -->
      <div class="layer__header">
        <div class="lyr-title">メンバーシップ選択</div>
        <div class="ft-point">決済方法を選択してください。</div>
        <div class="lyr-txt">その他の決済手段はカウンターの利用をお願いします。</div>
      </div>
      <!-- //header -->

      <!-- body -->
      <div class="layer__body mg-sm">
        <div class="regist-pay">
          <div class="touchbox on">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
          <div class="touchbox">
            <img src="@/assets/images/user/logo02.png" alt="" class="pay-logo" />
          </div>
        </div>
        <div class="flex-row">
          <div class="input-area">
            <label for="">핸드폰번호</label>
            <input type="text" placeholder="'-'없이 핸드폰번호만 입력" />
            <button class="btn-eye"></button>
            <!-- <button class="btn-eye masking"></button> -->
          </div>
          <div class="input-area">
            <label for="">승인번호</label>
            <input type="text" placeholder="승인번호 n자리 입력" />
          </div>
          <div class="keypad-regist">
            <div class="keypad">
              <button>1</button>
              <button>2</button>
              <button>3</button>
              <button>4</button>
              <button>5</button>
              <button>6</button>
              <button>7</button>
              <button>8</button>
              <button>9</button>
              <button class="delete">전체<br />삭제</button>
              <button>0</button>
              <button class="btn-back">삭제</button>
            </div>
          </div>
        </div>
      </div>
      <!-- //body -->

      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="$emit('closeRegisOrder')">閉める</button>
        <button class="btn btn--submit" @mouseup="$emit('regisOrder')">かごに入れる</button>
      </div>
    </div>
    <!-- //modal -->
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'registrationPay',
  data() {
    return {};
  },
  props: {},
  methods: {},
  mounted() {},
};
</script>

<style src='@/assets/css/user/common.css' scoped></style>
<style src='@/assets/css/user/pages/keypad.css' scoped></style>
<style src='@/assets/css/user/pages/touchbox.css' scoped></style>
<style src='@/assets/css/user/pages/admin.css' scoped></style>
<style scoped>
</style>
